import { About, Solution, Offer } from './common/pages';
import { Box } from '@mui/material';

export const Landing = () => {

  return (
    <Box sx={{paddingTop: '5rem', position: 'inherit'}}>
      <About />
      <Solution />
      <Offer />
    </Box>
  );
};
